import React, { useEffect, useState } from "react";
import HoriBarChart from "../../../components/Charts/HorizontalBarChart";
import { Loader } from "rsuite";
import { axInst, axInstBasic } from "../../../components/Service/Service";

// const serviceTypeApi = async (Arn) => {
//   const basicAuth =
//     "Basic " +
//     btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
//   try {
//     const res = await axInst.post(
//       `${process.env.REACT_APP_API_URL}ServiceTypeJC`,
//       {
//         isSearchArn: Arn,
//       },
//       {
//         headers: {
//           Authorization: basicAuth,
//         },
//       }
//     );
//     return res.data.result;
//   } catch (error) {
//     console.error(
//       "API Error:",
//       error.response ? error.response.data : error.message
//     );
//     throw error;
//   }
// };

export const serviceTypeApi = async (isSearchArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ServiceTypeJC`,{isSearchArn}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default function ServiceType({
  isSearchArn,
  isArn,
  setIsSearchArn,
  isWaterMark,
}) {
  const [horichart, setHorichart] = useState(null);
  const [isWaterMarkData, setIsWaterMarkData] = useState(null);

  useEffect(() => {
    if (isSearchArn && isArn) {
      serviceTypeApi(isArn)
        .then((data) => {
          setHorichart(data); // Store fetched data
        })
        .catch((error) => {
          console.error("Error fetching total open JC:", error);
        });
    }
    setIsSearchArn(false);
  }, [isSearchArn, isArn, setIsSearchArn]);
  useEffect(() => {
    setIsWaterMarkData(isWaterMark);
  }, [isWaterMark]);
  // Extract key and doc_count data for chart
  const keyData =
    horichart?.buckets?.map((bucket) => bucket.key).reverse() || [];
  const valData =
    horichart?.buckets?.map((bucket) => bucket.doc_count).reverse() || [];
  if (!horichart) {
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  }
  return (
    <div className="p-2 relative">
      <div>
        {isWaterMarkData && (
          <div className="absolute inset-0 flex items-center justify-center opacity-25 text-1xl text-center z-50">
            <div>
              <div>{isWaterMarkData.userId}</div>
              <div>{isWaterMarkData.date}</div>
              <div>{isWaterMarkData.ip}</div>
            </div>
          </div>
        )}
        <HoriBarChart data={{ keyData, valData }} top="10%" height="200px" />
      </div>
    </div>
  );
}
